import store from '../store'
import { setSession, getSession } from '@/util'
import { getAllProvinces } from '@/api/tyre'
export const getDefaultCityId = async () => {
  let cityId = ''
  let provinces = getSession('getAllProvinces')
  if (provinces) {
    cityId = await getCityId(provinces)
  } else {
    let { provinces } = await getAllProvinces()
    cityId = await getCityId(provinces)
    setSession('getAllProvinces', provinces)
  }
  return cityId
}

export const getCityId = async data => {
  return new Promise(resolve => {
    let { city } = store.state.locationInfo
    for (const province of data) {
      let getCity = province.cities.find(item => item.name === city)
      if (getCity) {
        store.commit('SETCURRENTCITY', getCity)
        resolve(getCity.id)
        break
      }
    }

    // 无法匹配当前城市的id，返回0
    resolve(0)
  })
}

export const getProvinceIdAndCityId = async (provinceName, cityName) => {
  let province, city

  let provinces = getSession('getAllProvinces')
  if (provinces) {
    province = provinces.find(p => p.name === provinceName)
  } else {
    let { provinces } = await getAllProvinces()
    province = provinces.find(p => p.name === provinceName)
    setSession('getAllProvinces', provinces)
  }
  if (!province) return []

  city = province.cities.find(c => c.name === cityName)

  if (!city) return []

  return [province.id, city.id]
}
